<template>
    <NuxtRouteAnnouncer />
    <Navigation />
    <BackgroundCanvas />
    <ActionButton />
    <NuxtPage />
    <Footer> </Footer>
</template>

<style lang="scss">
@use "~/assets/scss/main.scss";

// .page-enter-active,
// .page-leave-active {
//     transition: all 0.4s;
// }

// .page-enter-from,
// .page-leave-to {
//     opacity: 0;
//     filter: blur(1rem);
// }
</style>
